module.exports = __webpack_public_path__ + "img/img_takashi.ddcc245a.webp";